const BASE_OBJ = {
  DEV: "http://localhost:4000",
  TEST: "https://games.esmartlotto.ie",
  PROD: "https://games.smartlotto.ie",
  RESULT_APP_BASE: {
    PROD: "https://results.smartlotto.ie/",
    TEST: "https://results.esmartlotto.ie/",
    DEV: "http://results.esmartlotto.ie/",
  },
  WP_APP_BASE: {
    PROD: "https://smartlotto.ie/",
    TEST: "https://smartlotto.ie/",
    DEV: "https://esmartlotto.ie/",
  },
  MAIN_DOMAIN: {
    PROD: "smartlotto.ie",
    TEST: "esmartlotto.ie",
    DEV: "",
  },
  FB_APPID: {
    PROD: "683660528859825",
    TEST: "590669101830736",
    DEV: "641185313141974",
  },
  PAYMENT_APP_BASE: {
    PROD: "https://pay.smartlotto.ie/",
    TEST: "https://pay.esmartlotto.ie/",
    DEV: "http://localhost:8082/",
  },
  NEW_APP_BASE: {
    PROD: "https://player.smartlotto.ie/",
    TEST: "https://player.esmartlotto.ie/",
    DEV: "http://localhost:4200/",
  },
  CLUB_APP_BASE: {
    PROD: "https://club.smartlotto.ie/",
    TEST: "https://club.esmartlotto.ie/",
    DEV: "http://localhost:9000/",
  },
};

export class BaseCalss {
  env: string;
  baseHost: string;
  baseApiUrl: string;
  imageBaseUrl: string;

  resultAppBase: string;
  wpAppBase: string;

  paymentAppBase: string;

  newAppBase: string;
  // clubAppBase: string;

  fbAppId: string;
  domain: string;
  constructor() {
    this.env = 'PROD';  // PROD, DEV, TEST
    this.baseHost = BASE_OBJ[this.env];
    this.fbAppId = BASE_OBJ.FB_APPID[this.env];
    this.resultAppBase = BASE_OBJ.RESULT_APP_BASE[this.env];
    this.wpAppBase = BASE_OBJ.WP_APP_BASE[this.env];
    this.domain = BASE_OBJ.MAIN_DOMAIN[this.env];

    this.paymentAppBase = BASE_OBJ.CLUB_APP_BASE[this.env]; // BASE_OBJ[this.env]; //
    this.baseApiUrl = `${this.baseHost}/api/`;
    this.imageBaseUrl = this.baseHost;
    this.newAppBase = BASE_OBJ.NEW_APP_BASE[this.env];
    // this.clubAppBase = BASE_OBJ.CLUB_APP_BASE[this.env];
  }
}
